module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"filter":"Filtrovat podle"},"de":{"filter":"Filtern nach"},"es":{"filter":"Filtrado por"},"fr":{"filter":"Filtrer par"}}')
  delete Component.options._Ctor
}
